/**
 * TeamProfileModal
 * 팀원 카드 클릭 시 프로필 모달 표시. 재사용 가능한 프로필 모달 콘텐츠 구조 사용.
 */
import { Modal } from "./ui/Modal.js";

const DATA_SCRIPT_ID = "teamMembersData";
const GRID_SELECTOR = ".no-about-management__team-grid";
/** 갤러리형(.no-about-management__card) + 카드형(.no-about-management-card) 모두 클릭 시 모달 */
const CARD_SELECTOR = "[data-team-member-id]";

/**
 * 프로필 본문 HTML 생성 (BEM: no-profile-modal)
 * 직책은 모달 헤더(subtitle)에 표시하므로 body에는 포함하지 않음.
 * @param {{ name: string, titleKo: string, titleEn: string, career: string[], contents_html?: string }} member
 * @returns {string}
 */
function buildProfileBodyHtml(member) {
    if (member.contents_html && member.contents_html.trim() !== "") {
        return `<div class="no-profile-modal"><div class="no-profile-modal__content"><div class="no-profile-modal__body-html">${member.contents_html}</div></div></div>`;
    }

    const listItems =
        Array.isArray(member.career) && member.career.length > 0
            ? member.career
                  .map(
                      (line) =>
                          `<li class="no-profile-modal__item no-body-md">${escapeHtml(line)}</li>`
                  )
                  .join("")
            : "";
    const list =
        listItems &&
        `<ul class="no-profile-modal__list" aria-label="경력 및 학력">${listItems}</ul>`;

    return `<div class="no-profile-modal">${list || ""}</div>`;
}

function escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
}

/**
 * 팀원 데이터 로드
 * @returns {Array<{ name: string, titleKo: string, titleEn: string, career: string[] }>|null}
 */
function getTeamMembers() {
    const el = document.getElementById(DATA_SCRIPT_ID);
    if (!el || !el.textContent) return null;
    try {
        return JSON.parse(el.textContent);
    } catch {
        return null;
    }
}

export class TeamProfileModal {
    constructor() {
        this.teamMembers = null;
        this.boundHandleCardAction = this.handleCardAction.bind(this);
    }

    init() {
        const grid = document.querySelector(GRID_SELECTOR);
        if (!grid) return;

        this.teamMembers = getTeamMembers();
        if (!this.teamMembers || !this.teamMembers.length) return;

        grid.addEventListener("click", this.boundHandleCardAction);
        grid.addEventListener("keydown", this.boundHandleCardAction);
    }

    /**
     * @param {Event} e
     */
    handleCardAction(e) {
        const card =
            e.target.closest &&
            e.target.closest(CARD_SELECTOR);
        if (!card) return;

        if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") return;
        if (e.type === "keydown") {
            e.preventDefault();
        }

        const id = card.getAttribute("data-team-member-id");
        if (id == null) return;
        const index = parseInt(id, 10);
        if (Number.isNaN(index) || index < 0 || index >= this.teamMembers.length)
            return;

        this.openProfile(this.teamMembers[index]);
    }

    /**
     * @param {{ name: string, titleKo: string, titleEn: string, career: string[], contents_html?: string }} member
     */
    openProfile(member) {
        const title = member.name;
        const subtitle = member.titleEn || member.titleKo || member.position || "";
        const bodyHtml = buildProfileBodyHtml(member);

        Modal.custom(bodyHtml, "profile", {
            title,
            subtitle,
            depth: Modal.DEPTH.MEDIUM,
        });
    }

    destroy() {
        const grid = document.querySelector(GRID_SELECTOR);
        if (grid) {
            grid.removeEventListener("click", this.boundHandleCardAction);
            grid.removeEventListener("keydown", this.boundHandleCardAction);
        }
        this.teamMembers = null;
    }
}
